//域名
const baseURL = 'https://api.cjb.com.cn/prod-api'
// const baseURL = 'http://192.168.0.149:9700'
// 深拷贝
function  deepClone(data) {
	const type = judgeType(data);
	let obj;
	if (type === 'array') {
	  obj = [];
	} else if (type === 'object') {
	  obj = {};
	} else {
  // 不再具有下一层次
	  return data;
	}
	if (type === 'array') {
	  // eslint-disable-next-line
	  for (let i = 0, len = data.length; i < len; i++) {
		obj.push(deepClone(data[i]));
	  }
	} else if (type === 'object') {
	  // 对原型上的方法也拷贝了....
	  // eslint-disable-next-line
	  for (const key in data) {
		obj[key] = deepClone(data[key]);
	  }
	}
	return obj;
  }
function  judgeType(obj) {
// tostring会返回对应不同的标签的构造函数
	const toString = Object.prototype.toString;
	const map = {
	  '[object Boolean]': 'boolean',
	  '[object Number]': 'number',
	  '[object String]': 'string',
	  '[object Function]': 'function',
	  '[object Array]': 'array',
	  '[object Date]': 'date',
	  '[object RegExp]': 'regExp',
	  '[object Undefined]': 'undefined',
	  '[object Null]': 'null',
	  '[object Object]': 'object',
	};
	if (obj instanceof Element) {
	  return 'element';
	}
	return map[toString.call(obj)];
  }
/*
 *时间戳格式化
 */
 const formatDate = (timeStamp, fmt) => {
	if (timeStamp === '') return '';
	let date = new Date();
	date.setTime(timeStamp);
	if (!fmt) var fmt = 'yyyy-MM-DD hh:mm:ss';
	var o = {
		"M+": (date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1), // 月
		"D+": date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate(), // 日
		"h+": date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours(), // 时
		"m+": date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes(), // 分
		's+': date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds() // 秒
	}
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ?
				(o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
		}
	}
	return fmt;
}
  export default {
	deepClone,
	formatDate,
	baseURL
  }



// WEBPACK FOOTER //
// ./src/utils/utils.js